<!--
 * @Author: your name
 * @Date: 2020-06-22 10:51:45
 * @LastEditTime: 2020-09-25 08:46:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dudao\src\App.vue
-->
<template>
  <div id="app">
    <header>
      <router-link :to="'/'" :class="{active:$route.path=='/'}" tag="div" class="logo">
        <img src="../src/assets/img/logo.png" alt />
      </router-link>
      <i class="el-icon-more mobile" @click="show=true" />
      <div class="navigator pc">
        <router-link :to="'/'" :class="{active:$route.path=='/'}" tag="div">首頁</router-link>
        <router-link
          to
          tag="div"
          class="about"
          @mouseenter.native="enter"
          @mouseleave.native="leve"
          :class="{active:$route.path=='/store' ||$route.path=='/about' }"
        >
          關於讀道
          <div>
            <div class="box">
              <div @click="$router.push({path:'/about'})" class="box-options">
                <p>
                  <span class="name">
                    品牌故事
                    <br />
                    <span class="en">Brand story</span>
                  </span>
                  <img src="../src/assets/img/arrow-right.png" alt srcset />
                </p>
                <label for></label>
                <img src="../src/assets/img/story.png" alt srcset />
              </div>
              <div @click="$router.push({path:'/store'})" class="box-options">
                <p>
                  <span class="name">
                    门店展示
                    <br />
                    <span class="en">Store display</span>
                  </span>
                  <img src="../src/assets/img/arrow-right.png" alt srcset />
                </p>
                <label for></label>
                <img src="../src/assets/img/store-show.png" alt srcset />
              </div>
            </div>
          </div>
        </router-link>
        <router-link
          :to="{path:'/jadeite'}"
          tag="div"
          :class="{active:$route.path.indexOf('/jadeite') !== -1}"
        >翡翠系列</router-link>
        <router-link
          :to="{path:'/emerald'}"
          tag="div"
          :class="{active:$route.path.indexOf('/emerald') !== -1}"
        >祖母綠系列</router-link>
        <router-link
          to
          tag="div"
          class="about customized"
          @mouseenter.native="enter"
          @mouseleave.native="leve"
          :class="{active:$route.path=='/customized' || $route.path.indexOf('/diamond' ) !== -1|| $route.path.indexOf('/spinel') !==-1  }"
        >
          裸石高級定制
          <div>
            <div class="box">
              <div class="left-box">
              <div class="box-options" @click="$router.push({path:'/spinel'})">
                  <img src="../src/assets/img/spinel.jpg" alt srcset />
                  <div>
                    <span class="name">
                      绝地武士定制系列
                      <br />
                      <span class="en">Jedi Knight</span>
                    </span>
                    <p for>
                      查看更多
                      <img src="../src/assets/img/arrow-right.png" alt srcset />
                    </p>
                  </div>
                </div>
                <div class="box-options" @click="$router.push({path:'/diamond'})">
                  <img src="../src/assets/img/diamonds.png" alt srcset />
                  <div>
                    <span class="name">
                      钻石定制系列
                      <br />
                      <span class="en">Diamond</span>
                    </span>
                    <p for>
                      查看更多
                      <img src="../src/assets/img/arrow-right.png" alt srcset />
                    </p>
                  </div>
                </div>

              </div>
              <div @click="$router.push({path:'/customized'})" class="box-options">
                <p>
                  <span class="name">
                    定制流程
                    <br />
                    <span class="en">Customization process</span>
                  </span>
                  <img src="../src/assets/img/arrow-right.png" alt srcset />
                </p>
                <label for></label>
                <img src="../src/assets/img/custom.png" alt srcset />
              </div>
            </div>
          </div>
        </router-link>
        <router-link
          :to="{path:'/encyclopedias'}"
          tag="div"
          :class="{active:$route.path.indexOf('/ency') !== -1}"
        >珠寶百科</router-link>
        <div class="into" @click="to">
          <span>进入店铺</span>
        </div>
      </div>
    </header>
    <router-view class="router-view" />
    <footer>
      <div class="pc">
        <div>
          <p>聯係我們</p>
          <div>
            <img v-popover:email src="../src/assets/img/circle-img.png" alt slot="reference" />

            <img v-popover:phone src="../src/assets/img/circle-phone.png" alt class="mid" />

            <img v-popover:address src="../src/assets/img/circle-address.png" alt srcset />
          </div>
          <span class="hrs"></span>
        </div>
        <img src="../src/assets/img/logo.png" alt @click="$router.push({path:'/'})" />
        <div>
          <p>關注我們</p>
          <div>
            <img v-popover:weibo src="../src/assets/img/sina.png" alt srcset />

            <img v-popover:taobao src="../src/assets/img/taobao.png" alt class="mid" />

            <img v-popover:wechat src="../src/assets/img/weixin.png" alt srcset />
          </div>
          <span class="hrs"></span>
        </div>
      </div>
      <div class="mobile">
        <img src="../src/assets/img/logo.png" alt srcset @click="$router.push({path:'/'})" />
        <div>
          <span>聯係我們</span>
          <img v-popover:email1 src="../src/assets/img/circle-img.png" alt srcset />
          <img v-popover:phone1 src="../src/assets/img/circle-phone.png" alt srcset />
          <img v-popover:address1 src="../src/assets/img/circle-address.png" alt srcset />
        </div>
        <div>
          <span>關注我們</span>
          <img v-popover:weibo1 src="../src/assets/img/sina.png" alt srcset />
          <img v-popover:taobao1 src="../src/assets/img/taobao.png" alt srcset />
          <img v-popover:wechat1 src="../src/assets/img/weixin.png" alt srcset />
        </div>
      </div>
      <p>
        <label class="pc">
          <router-link tag="span" :to="{path:'/'}">首頁</router-link>
          <router-link tag="span" :to="{path:'/emerald'}">祖母綠系列</router-link>
          <router-link tag="span" :to="{path:'/jadeite'}">翡翠系列</router-link>
          <!-- <router-link tag="span" :to="{path:'/spinel'}">尖晶石系列</router-link> -->
          <router-link tag="span" :to="{path:'/diamond'}">鑽石系列</router-link>
          <router-link tag="span" :to="{path:'/customized'}">裸石高級定制</router-link>
          <router-link tag="span" :to="{path:'/about'}">關於讀道</router-link>
          <router-link tag="span" :to="{path:'/encyclopedias'}">珠寶百科</router-link>
        </label>
        <a
          href="http://beian.miit.gov.cn/"
          target="_blank"
        >Copyright © 2021- 2022 版权所有:读道珠宝设计工作室, All Rights Reserved | 蜀ICP备20006000号-1
        </a>
      </p>
    </footer>
    <el-drawer :visible.sync="show" direction="rtl" size="100%" :show-close="false">
      <router-link
        :to="'/'"
        :class="{active:$route.path=='/'}"
        tag="h1"
        slot="title"
        class="mobile title"
      >
        <img src="../src/assets/img/logo.png" alt srcset />
      </router-link>
      <router-link :to="'/'" class="mobile router" tag="div">首頁</router-link>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="關於讀道" :name="1">
          <router-link :to="'/about'" class="mobile router collapse" tag="div">品牌故事</router-link>
          <router-link :to="'/store'" class="mobile router collapse" tag="div">门店展示</router-link>
        </el-collapse-item>
      </el-collapse>
      <router-link :to="{path:'/jadeite'}" tag="div" class="mobile router">翡翠系列</router-link>
      <router-link :to="{path:'/emerald'}" tag="div" class="mobile router">祖母綠系列</router-link>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="裸石高級定制" :name="2">
          <router-link :to="'/diamond'" class="mobile router collapse" tag="div">钻石定制系列</router-link>
          <!-- <router-link :to="'/spinel'" class="mobile router collapse" tag="div">尖晶石定制系列</router-link> -->
          <router-link :to="'/customized'" class="mobile router collapse" tag="div">定制流程</router-link>
        </el-collapse-item>
      </el-collapse>
      <router-link :to="{path:'/encyclopedias'}" class="mobile router" tag="div">珠寶百科</router-link>
      <router-link to=" " tag="div" class="mobile router" @click.native="to">进入店铺</router-link>
      <el-button type="primary" plain @click="show =false" style="margin:20px auto;display:block">关闭</el-button>
    </el-drawer>
    <!--  -->
    <el-popover ref="email" placement="top" width="200" trigger="hover" :content="shop.email"></el-popover>
    <el-popover ref="phone" placement="top" width="200" trigger="hover" :content="shop.custom_tel"></el-popover>
    <el-popover ref="address" placement="top" width="200" trigger="hover" :content="shop.address"></el-popover>
    <el-popover ref="weibo" placement="top" width="200" trigger="hover">
      <img :src="shop.weibo" class="hover-img" />
    </el-popover>
    <el-popover ref="taobao" placement="top" width="200" trigger="hover">
      <img :src="shop.taobao" class="hover-img" />
    </el-popover>
    <el-popover ref="wechat" placement="top" width="200" trigger="hover">
      <img :src="shop.wechat" class="hover-img" />
    </el-popover>
    <!--  -->
    <el-popover ref="email1" placement="top" width="200" trigger="hover" :content="shop.email"></el-popover>
    <el-popover ref="phone1" placement="top" width="200" trigger="hover" :content="shop.custom_tel"></el-popover>
    <el-popover ref="address1" placement="top" width="200" trigger="hover" :content="shop.address"></el-popover>
    <el-popover ref="weibo1" placement="top" width="200" trigger="hover">
      <img :src="shop.weibo" class="hover-img" />
    </el-popover>
    <el-popover ref="taobao1" placement="top" width="200" trigger="hover">
      <img :src="shop.taobao" class="hover-img" />
    </el-popover>
    <el-popover ref="wechat1" placement="top" width="200" trigger="hover">
      <img :src="shop.wechat" class="hover-img" />
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      shop: {},
      show: false,
      activeName: 1,
    };
  },
  watch: {
    "$route.path": {
      handler() {
        this.show = false;
        document.getElementsByClassName("hover")[0].classList.remove("hover");
      },
    },
  },
  created() {
    this.axios.get("config/info").then((r) => {
      this.shop = { ...r };
    });
  },
  methods: {
    enter(e) {
      console.log(e);
      e.currentTarget.classList.add("hover");
    },
    leve(e) {
      e.currentTarget.classList.remove("hover");
    },
    to() {
      let tb = JSON.parse(localStorage.getItem("shop")).tianmao_url;
      window.open(tb);
    },
  },
};
</script>

<style lang="less">
@font-face {
  font-family: "FZShuSong-Z01T";
  src: url("../src/assets/font/FZSSFW.ttf");
}
@font-face {
  font-family: "Baskerville Old Face";
  src: url("../src/assets/font/baskoldface.ttf");
}
html,
body {
  overflow-x: hidden;
  min-width: 1200px;
}
@media (min-width: 1200px) {
  overflow-x: auto;
}
html,
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin: 0;
  padding: 0;
}
ul {
  list-style: none;
}
h1 {
  font-size: 0.3rem;
  font-family: "FZShuSong-Z01T";
  color: rgba(0, 0, 0, 1);
}
.en {
  font-size: 0.16rem;
  font-family: "Baskerville Old Face";
  color: rgba(0, 0, 0, 1);
}
h1,
.en {
  text-align: center;
}
.rich {
  font-family: "FZShuSong-Z01T";
  img,
  video {
    max-width: 100%;
  }
}
.el-collapse-item__content {
  padding-bottom: 0 !important;
}
.router-view {
  padding-bottom: 0.66rem;
}
.el-pager li.active {
  color: white !important;
}
.head {
  height: 0.5rem;
  background: rgba(242, 242, 242, 1);
  text-align: center;
  line-height: 0.5rem;
  font-size: 0.2rem;
  font-family: "FZShuSong-Z01T";
  font-weight: 400;
  color: rgba(127, 109, 70, 1);
  letter-spacing: 0.06rem;
  user-select: none;
}
.el-pagination {
  text-align: center;
}
.el-pager li.active {
  background: #7f6d46;
  border-radius: 50%;
  color: white;
  min-width: 28px;
  padding: 0;
}
.el-breadcrumb,
.el-breadcrumb i,
.el-breadcrumb__inner {
  color: #7f6d46;
}
a {
  text-decoration: none;
}
#app {
  font-weight: 400;
  min-height: 100vh;
  & > header {
    width: 100%;
    height: 1.73rem;
    position: relative;
    min-height: 108px;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05);
    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.2rem 0;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(145, 145, 145, 0.1);
      img {
        width: 1.73rem;
        cursor: pointer;
        min-width: 108px;
      }
    }

    .navigator {
      display: flex;
      justify-content: center;
      height: 0.7rem;
      align-items: center;
      padding-bottom: 5px;
      box-sizing: border-box;
      & > div {
        height: 100%;
        line-height: 0.7rem;
        font-size: 0.16rem;
        font-family: "FZShuSong-Z01T";
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        transition: all 0.3s linear;
        box-sizing: border-box;
        cursor: pointer;
      }
      .into {
        display: flex;
        align-items: center;
        span {
          border-radius: 0.15rem;
          display: block;
          height: 0.3rem;
          line-height: 0.3rem;
          padding: 0 0.1rem;
          background: #7f6d46;
          color: white;
        }
      }
      .customized.about {
        & > div {
          padding: 0;
          .box {
            margin: 0 auto;
            padding: 0.5rem;
            box-sizing: content-box;
            div.left-box {
              & > div {
                display: flex;
                width: 100%;
                align-items: flex-end;
                margin-bottom: 0.4rem;
                & > img {
                  width: 3.6rem;
                  height: 2.36rem;
                  margin: 0;
                }
                div {
                  display: flex;
                  flex-direction: column;
                  padding: 0.52rem 0.24rem;
                  box-sizing: border-box;
                  justify-content: space-between;
                  line-height: 0.16rem;
                  padding-top: 0.12rem;
                  height: 2.36rem;

                  p {
                    width: 100%;
                    border: none;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    img {
                      width: 0.46rem;
                      height: 0.22rem;
                      margin: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .about {
        .box-options:hover {
          & > img {
            transform: scale(1.1, 1.1);
          }
        }
        & > div {
          display: flex;
          position: absolute;
          top: 1.73rem;
          width: 100vw;
          padding: 0 3.6rem;
          background: white;
          box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.1);
          left: -200%;
          .box {
            padding: 0.8rem;
            background: #eeeeee;
            width: 12rem;
            box-sizing: border-box;
            display: flex;
            div {
              width: 50%;
              p {
                display: flex;
                justify-content: space-between;
                align-items: center;
                img {
                  width: 46px !important;
                  height: 22px;
                }
              }
              label {
                display: inline-block;
                width: 0.66rem;
                height: 0px;
                border: 2px solid rgba(0, 0, 0, 1);
              }
              img {
                width: 4.41rem;
                height: 2.9rem;
                margin-top: 0.47rem;
                display: block;
                transition: all 0.3s linear;
              }
            }
          }
        }
        span.name {
       line-height: 24px;
          font-size: 0.18rem;
          font-family: "FZShuSong-Z01T";
          span {
            font-size: 0.16rem;
            font-family: "Baskerville Old Face";
          }
        }
      }
      .about.hover {
        div {
          z-index: 12;
          left: 0;
        }
      }
      div:hover {
        color: rgba(0, 0, 0, 0.78);
      }
      div:not(:last-child) {
        margin-right: 0.9rem;
      }
      div.active {
        color: rgba(0, 0, 0, 1);
        border-bottom: 2px solid rgba(0, 0, 0, 1);
      }
    }
  }

  footer {
    & > div {
      background: #f7f7f7;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding: 0.37rem 0;
      & > img {
        width: 1.73rem;
        margin: 0 3.16rem;
        cursor: pointer;
      }
      & > div {
        padding-bottom: 0.1rem;
        position: relative;
        .hrs {
          display: inline-block;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 1.29rem;
          height: 2px;
          background: rgba(0, 0, 0, 0.2);
        }
        p {
          text-align: center;
          font-size: 0.16rem;
          font-family: "FZShuSong-Z01T";
          font-weight: 400;
          margin-bottom: 0.21rem;
        }
        div {
          img {
            width: 0.51rem;
            height: 0.51rem;
          }
          img.mid {
            margin: 0 0.33rem;
          }
        }
      }
    }
    & > p {
      padding: 0.13rem 1.5rem;
      display: flex;
      justify-content: space-between;
      label {
        span {
          padding: 0 0.2rem;
          border-right: 1px solid rgba(0, 0, 0, 0.2);
          font-size: 0.14rem;
          font-family: "FZShuSong-Z01T";
          font-weight: 400;
          color: rgba(0, 0, 0, 0.58);
          cursor: pointer;
        }
      }
      a {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        text-decoration: none;
        color: black;
      }
    }
  }
  .en {
    text-transform: uppercase;
  }
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-overflow-more {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.text-overflow-more-2 {
  -webkit-line-clamp: 2;
}
.text-overflow-more-3 {
  -webkit-line-clamp: 3;
}
.text-overflow-more-4 {
  -webkit-line-clamp: 4;
}
.text-overflow-more-6 {
  -webkit-line-clamp: 6;
}
.hover-img {
  width: 150px;
  height: 150px;
}
@media (min-width: 768px) {
  .mobile {
    display: none !important;
  }
}
@media (max-width: 767px) {
  html,
  body {
    min-width: unset;
  }
  .rich {
    line-height: 22px !important;
  }
  .pc {
    display: none !important;
  }
  h1.mobile.title {
    img {
      width: 50%;
    }
  }
  div.mobile.router {
    font-family: FZShuSong-Z01T;
    font-size: 14px;
    padding: 15px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
  }
  div.mobile.router.collapse {
    padding-left: 20px;
    font-size: 13px;
  }
  .el-collapse-item__header {
    padding-left: 10px;
  }
  #app {
    header {
      height: auto;
      min-height: unset;
      position: relative;
      i.mobile {
        font-size: 30px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
      }
      i.mobile:active {
        opacity: 0.5;
      }
    }
    footer {
      & > .mobile {
        display: block;
        img {
          display: block;
          margin: 10px auto;
          width: 30%;
        }
        span {
          display: inline;
          position: unset;
          background: transparent;
          transform: unset;
          width: unset;
          margin-right: 30px;
        }
        div {
          display: flex;
          margin: 20px 0;
          padding: 0 20px;
          img {
            width: 30px;
            height: 30px;
            margin: 0;
            margin-left: 20px;
          }
        }
      }
    }
  }
  .head {
    height: 50px;
    line-height: 50px;
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue